export default "__VITE_ASSET__B9o6idwX__"